module.exports = __webpack_public_path__ + "static/media/Ravani-sm.6ce8514c.jpg";